import {
  paymentFulfillmentStatuses,
  type PaymentFulfillmentStatus,
} from "../types/PaymentFulfillmentStatus";

export const paymentFulfillmentSelectOptions: {
  value: PaymentFulfillmentStatus;
  label: string;
}[] = paymentFulfillmentStatuses.map((value) => ({
  value,
  label: paymentFulfillmentLabel(value),
}));

function paymentFulfillmentLabel(status: PaymentFulfillmentStatus): string {
  switch (status) {
    case "unfulfilled":
      return "Unfulfilled";
    case "fulfilled":
      return "Fulfilled";
    case "partially_fulfilled":
      return "Partially fulfilled";
    case "shipped":
      return "Shipped";
    case "cancelled":
      return "Cancelled";
    default:
      return status;
  }
}

export function formatPaymentFulfillmentStatus(
  status?: PaymentFulfillmentStatus | string | null,
): string {
  if (!status) return "Unfulfilled";
  const found = paymentFulfillmentStatuses.find((s) => s === status);
  if (!found) return String(status);
  return paymentFulfillmentLabel(found);
}
